import { render, staticRenderFns } from "./PainelChamadosSein.vue?vue&type=template&id=35b243a5"
import script from "./PainelChamadosSein.vue?vue&type=script&lang=js"
export * from "./PainelChamadosSein.vue?vue&type=script&lang=js"
import style0 from "./PainelChamadosSein.vue?vue&type=style&index=0&id=35b243a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports